<template>
    <el-dialog v-model="dialog_opened" width="84%" :title="collection?collection.i18n_name.ZH_HANS:''">
        <div class="story-image-toolbar">
            <h4>共 {{ data.length }} 张</h4>
            <div>
                <el-tag v-if="sortSaving" type="warning" style="margin-right: 8px">排序保存中</el-tag>
                <el-button type="primary" :loading="loading" :disabled="sortSaving" @click="openImagePicker">向集合中添加图片</el-button>
            </div>
        </div>
        <div v-loading="loading" class="story-image-list">
            <div class="story-image-header">
                <span class="drag-col">排序</span>
                <span class="id-col">ID</span>
                <span class="status-col">状态</span>
                <span class="image-col">图片</span>
                <span class="title-col">章节标题 EN</span>
                <span class="desc-col">章节短描述 EN</span>
                <span class="action-col">操作</span>
            </div>
            <vue-draggable-next
                v-model="data"
                :animation="200"
                :disabled="sortSaving"
                handle=".drag-handle"
                @change="resort"
            >
                <div v-for="row in data" :key="row.id" class="story-image-row">
                    <span class="drag-col drag-handle">拖动</span>
                    <span class="id-col">{{ row.image_id }}</span>
                    <span class="status-col">
                        <span style="color: var(--el-color-success)" v-if="row.status==='AUDITED'">
                            <el-icon><CircleCheckFilled/></el-icon> 通过
                        </span>
                        <span style="color: var(--el-color-warning)" v-else-if="row.status==='AUDITING'">
                            <el-icon><Loading/></el-icon> 审核中
                        </span>
                        <span style="color: var(--el-color-error)" v-else-if="row.status==='REJECTED'">
                            <el-icon><CircleCloseFilled/></el-icon> 不通过
                        </span>
                    </span>
                    <span class="image-col">
                        <el-image lazy :src="row.thumbnail" style="width: 140px"/>
                    </span>
                    <span class="title-col">
                        <el-input :disabled="loading" v-model="row.i18n_name.EN" @change="update(row)"></el-input>
                    </span>
                    <span class="desc-col">
                        <el-input :disabled="loading" v-model="row.i18n_desc.EN" @change="update(row)"></el-input>
                    </span>
                    <span class="action-col">
                        <el-button type="warning" :disabled="loading || translate_loading" @click="openPreview(row)"
                                   circle size="small" icon="Switch"></el-button>
                        <el-button type="danger" :disabled="loading || sortSaving" @click="remove(row)" circle size="small"
                                   icon="Delete"></el-button>
                    </span>
                </div>
            </vue-draggable-next>
        </div>
        <div style="margin-top: 20px">
            <el-alert type="info" :closable="false" title="拖动图片即可调整排序，松手后会自动保存。"></el-alert>
        </div>
        <el-dialog v-model="preview_opened" title="章节多语言预览" width="70%" append-to-body>
            <div v-if="preview_row" class="story-preview-head">
                <el-image lazy :src="preview_row.thumbnail" style="width: 120px"/>
                <div>
                    <div class="story-preview-id">{{ preview_row.image_id }}</div>
                    <div>标题已填 {{ filledCount(preview_row.i18n_name) }} 个语言，短描述已填 {{ filledCount(preview_row.i18n_desc) }} 个语言</div>
                </div>
            </div>
            <div class="story-preview-actions">
                <el-button type="warning" icon="Switch" :loading="translate_loading"
                           :disabled="loading || translate_loading || !previewCanTranslate" @click="translatePreviewRow(false)">
                    翻译当前章节
                </el-button>
                <el-button type="warning" plain icon="Switch" :loading="translate_loading"
                           :disabled="loading || translate_loading || !previewCanTranslate" @click="translatePreviewRow(true)">
                    覆盖翻译当前章节
                </el-button>
                <span>默认只填空语言；如需重翻已有内容请使用覆盖翻译。</span>
            </div>
            <el-table :data="previewRows" max-height="520" style="margin-top: 12px">
                <el-table-column label="语言" prop="lang" width="90"></el-table-column>
                <el-table-column label="章节标题" prop="name" min-width="220">
                    <template #default="scope">
                        <el-input v-model="scope.row.name" :disabled="loading || scope.row.lang === 'EN'"
                                  placeholder="未填写"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="章节短描述" prop="desc" min-width="320">
                    <template #default="scope">
                        <el-input v-model="scope.row.desc" :disabled="loading || scope.row.lang === 'EN'"
                                  placeholder="未填写"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <el-button :disabled="loading || translate_loading" @click="preview_opened = false">取消</el-button>
                <el-button type="primary" :loading="loading" :disabled="translate_loading" @click="savePreviewRow">
                    保存
                </el-button>
            </template>
        </el-dialog>
    </el-dialog>
    <el-dialog v-model="picker.opened" width="86%" title="从图库选择集合图片">
        <div class="picker-filter">
            <el-input v-model="picker.query.id" prefix-icon="Search" @change="fetchPickerImages(1)"
                      placeholder="ID搜索" clearable style="width: 220px"></el-input>
            <el-select v-model="picker.query.module" placeholder="模块" disabled @change="fetchPickerImages(1)"
                       style="width: 120px">
                <el-option label="集合" value="COLLECTION"></el-option>
            </el-select>
            <el-select v-model="picker.query.category_ids" multiple clearable filterable collapse-tags
                       collapse-tags-tooltip placeholder="分类筛选" style="width: 220px"
                       @change="fetchPickerImages(1)">
                <el-option v-for="c in category_list" :key="c.id" :value="c.id"
                           :label="c.i18n_name.ZH_HANS"></el-option>
            </el-select>
            <el-cascader v-model="picker.query.major_tags" placeholder="主要标签" clearable filterable
                         :options="major_list" :props="tagProps" collapse-tags collapse-tags-tooltip
                         style="width: 300px" @change="fetchPickerImages(1)"></el-cascader>
        </div>
        <el-table v-loading="picker.loading" :data="picker.images" style="margin-top: 10px">
            <el-table-column label="图片" width="180">
                <template #default="scope">
                    <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`" style="width: 130px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="ID" prop="id" width="150"></el-table-column>
            <el-table-column label="模块" prop="module" width="100">
                <template #default="scope">{{ moduleLabel(scope.row.module) }}</template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="120">
                <template #default="scope">
                    <el-tag v-for="c in scope.row.categories" :key="c" size="small">{{ category_map[c] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="主要标签" prop="major_tags">
                <template #default="scope">
                    <el-tag v-for="t in scope.row.major_tags" :key="t" size="small">{{ major_map[t] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="来源" prop="source" width="120"></el-table-column>
            <el-table-column label="操作" width="100">
                <template #default="scope">
                    <el-button type="primary" size="small" :loading="scope.row._adding"
                               :disabled="loading || picker.loading || sortSaving || !canAddPickerImage(scope.row)"
                               @click="addImageFromPicker(scope.row)">
                        {{ pickerActionText(scope.row) }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            layout="total, sizes, prev, pager, next"
            :total="picker.total"
            :page-size="picker.query.limit"
            :current-page="picker.page"
            :page-sizes="[10, 50, 100]"
            @current-change="fetchPickerImages"
            @size-change="handlePickerPageSizeChange"
            :disabled="picker.loading"
            style="margin-top: 10px"
        ></el-pagination>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import {ElMessageBox, ElMessage} from 'element-plus';
import {VueDraggableNext} from 'vue-draggable-next'
import {initI18n} from "../libs/init";
import {
    i18nKeys,
    translateI18nFields
} from "../libs/i18nTranslate";

function apiError(e) {
    const m =
        e?.response?.data?.message ||
        e?.response?.data?.status?.message ||
        (typeof e?.response?.data === "string" ? e.response.data : null) ||
        e?.message;
    ElMessage.error(m || "请求失败");
}

export default {
    name: "StoryCollectionImage",
    components: {VueDraggableNext},
    data() {
        return {
            loading: false,
            translate_loading: false,
            sortSaving: false,
            dialog_opened: false,
            preview_opened: false,
            data: [],
            collection: null,
            preview_row: null,
            preview_rows: [],
            category_list: [],
            major_list: [],
            category_map: {},
            picker: {
                opened: false,
                loading: false,
                images: [],
                total: 0,
                page: 1,
                requestId: 0,
                query: {
                    status: 'AUDITED',
                    module: 'COLLECTION',
                    unassigned_online_date: true,
                    unassigned_collection: true,
                    id: '',
                    category_ids: [],
                    major_tags: null,
                    skip: 0,
                    limit: 10,
                },
            },
            tagProps: {expandTrigger: 'hover', label: 'name', value: 'id', emitPath: false, multiple: true},
        }
    },
    inject: ['major_map', 'minor_map', 'assistant_map'],
    methods: {
        moduleLabel(module) {
            return {LIBRARY: '图库', COLLECTION: '集合', DAILY: '每日', EVENT: '活动'}[module] || module || '未设置';
        },
        convertTagNames(list) {
            list.forEach(l => {
                l.name = l.i18n_name?.ZH_HANS || l.name;
                if (!l.children) {
                    l.children = [];
                }
                if (l.children.length) {
                    this.convertTagNames(l.children);
                }
            });
        },
        init(collection) {
            this.collection = collection;
            this.$nextTick(_ => {
                this.dialog_opened = this.loading = true;
                this.reloadImages();
            })
            this.loadPickerMeta();
        },
        reloadImages() {
            if (!this.collection) {
                return;
            }
            this.loading = true;
            axios.get(`/cms/v1/story-collection/${this.collection.id}/image`).then(res => {
                this.data = res.data.data.imageList.map(row => this.normalizeRowI18n(row));
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                apiError(e);
            })
        },
        normalizeRowI18n(row) {
            row.i18n_name = Object.assign(initI18n(), row.i18n_name || {});
            row.i18n_desc = Object.assign(initI18n(), row.i18n_desc || {});
            return row;
        },
        loadPickerMeta() {
            if (this.category_list.length && this.major_list.length) {
                return;
            }
            axios.all([
                axios.get(`/cms/v1/category`).then(res => {
                    this.category_list = res.data.data.categoryList.filter(c => !['ALL', 'COLLECTION'].includes(c.key));
                    this.category_list.forEach(c => {
                        this.category_map[c.id] = c.i18n_name.ZH_HANS;
                    });
                }),
                axios.get('/cms/v1/tag/major').then(res => {
                    this.major_list = res.data.data.tagList;
                    this.convertTagNames(this.major_list);
                }),
            ]).catch(e => apiError(e));
        },
        update(row) {
            this.loading = true;
            axios.put(`/cms/v1/story-collection/${this.collection.id}/image`, row).then(_ => {
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                apiError(e);
            })
        },
        buildRowTranslationRequest(rows) {
            const fields = {};
            const labels = {};
            rows.forEach((row, index) => {
                const prefix = row.image_id || row.id || String(index);
                const titleKey = `${prefix}_name`;
                const descKey = `${prefix}_desc`;
                if (row.i18n_name?.EN) {
                    fields[titleKey] = row.i18n_name;
                    labels[titleKey] = `第 ${this.data.indexOf(row) + 1} 章标题`;
                }
                if (row.i18n_desc?.EN) {
                    fields[descKey] = row.i18n_desc;
                    labels[descKey] = `第 ${this.data.indexOf(row) + 1} 章短描述`;
                }
            });
            return {fields, labels};
        },
        buildPreviewRows(row) {
            return i18nKeys().map(lang => {
                return {
                    lang,
                    name: row.i18n_name ? row.i18n_name[lang] : '',
                    desc: row.i18n_desc ? row.i18n_desc[lang] : '',
                }
            });
        },
        previewRowsToI18n() {
            const i18n_name = initI18n();
            const i18n_desc = initI18n();
            this.preview_rows.forEach(row => {
                i18n_name[row.lang] = row.name || '';
                i18n_desc[row.lang] = row.desc || '';
            });
            return {i18n_name, i18n_desc};
        },
        async translatePreviewRow(overwrite = false) {
            if (this.translate_loading || !this.preview_row) {
                return;
            }
            const current = this.previewRowsToI18n();
            const {fields} = this.buildRowTranslationRequest([{
                ...this.preview_row,
                i18n_name: current.i18n_name,
                i18n_desc: current.i18n_desc,
            }]);
            if (!Object.keys(fields).length) {
                ElMessage.warning('请先填写章节的 EN 标题或 EN 短描述');
                return;
            }
            this.translate_loading = true;
            try {
                const result = await translateI18nFields(fields, overwrite);
                const prefix = this.preview_row.image_id || this.preview_row.id || '0';
                let changed = 0;
                this.preview_rows.forEach(row => {
                    if (row.lang === 'EN') {
                        return;
                    }
                    const name = result.fields[`${prefix}_name`]?.[row.lang];
                    const desc = result.fields[`${prefix}_desc`]?.[row.lang];
                    if (name && (overwrite || !row.name)) {
                        if (row.name !== name) {
                            changed += 1;
                        }
                        row.name = name;
                    }
                    if (desc && (overwrite || !row.desc)) {
                        if (row.desc !== desc) {
                            changed += 1;
                        }
                        row.desc = desc;
                    }
                });
                if (!changed) {
                    ElMessage.warning('没有可用翻译结果');
                    return;
                }
                ElMessage.success(`已更新 ${changed} 个翻译项，请检查后保存`);
            } catch (err) {
                ElMessage.error(err.response?.data?.status?.message || '翻译失败，请检查后端翻译配置');
            } finally {
                this.translate_loading = false;
            }
        },
        openPreview(row) {
            this.preview_row = row;
            this.preview_rows = this.buildPreviewRows(row);
            this.preview_opened = true;
        },
        savePreviewRow() {
            if (!this.preview_row) {
                return;
            }
            const previewI18n = this.previewRowsToI18n();
            this.preview_row.i18n_name = previewI18n.i18n_name;
            this.preview_row.i18n_desc = previewI18n.i18n_desc;
            this.loading = true;
            axios.put(`/cms/v1/story-collection/${this.collection.id}/image`, this.preview_row).then(_ => {
                this.loading = false;
                this.preview_opened = false;
                ElMessage.success('保存成功');
            }).catch(e => {
                this.loading = false;
                apiError(e);
            })
        },
        filledCount(i18n) {
            return i18nKeys().filter(lang => i18n && i18n[lang]).length;
        },
        remove(row) {
            if (this.sortSaving) {
                return;
            }
            ElMessageBox.confirm('确定要从集合中删除该图片吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/story-collection/${this.collection.id}/image`, {data: {image_id: row.image_id}}).then(res => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.loading = false;
                    ElMessage.success('已从集合中删除');
                }).catch(e => {
                    this.loading = false;
                    apiError(e);
                })
            }).catch(_ => {
            })
        },
        openImagePicker() {
            if (this.sortSaving) {
                return;
            }
            this.picker.query.module = 'COLLECTION';
            this.picker.opened = true;
            this.loadPickerMeta();
            this.fetchPickerImages(1);
        },
        buildPickerParams() {
            const params = {...this.picker.query};
            params.skip = (this.picker.page - 1) * params.limit;
            if (!params.id) {
                delete params.id;
            }
            if (params.category_ids && params.category_ids.length) {
                params.category_ids = params.category_ids.join(',');
            } else {
                delete params.category_ids;
            }
            if (params.major_tags && params.major_tags.length) {
                params.major_tags = params.major_tags.join(',');
            } else {
                delete params.major_tags;
            }
            return params;
        },
        fetchPickerImages(page) {
            this.picker.page = page;
            this.picker.loading = true;
            const requestId = ++this.picker.requestId;
            axios.get(`/cms/v1/image`, {params: this.buildPickerParams()}).then(res => {
                if (requestId !== this.picker.requestId) {
                    return;
                }
                this.picker.images = res.data.data.imageList;
                this.picker.total = res.data.data.total;
                this.picker.loading = false;
            }).catch(e => {
                if (requestId !== this.picker.requestId) {
                    return;
                }
                this.picker.loading = false;
                apiError(e);
            })
        },
        handlePickerPageSizeChange(size) {
            this.picker.query.limit = size;
            this.fetchPickerImages(1);
        },
        isInCollection(imageId) {
            return this.data.some(i => i.image_id === imageId);
        },
        canAddPickerImage(row) {
            return !this.sortSaving && row.module === 'COLLECTION' && !this.isInCollection(row.id) && !row.collection_assigned;
        },
        pickerActionText(row) {
            if (this.isInCollection(row.id)) {
                return '已添加';
            }
            if (row.collection_assigned) {
                return '已在集合';
            }
            if (row.module !== 'COLLECTION') {
                return '非集合';
            }
            return '添加';
        },
        addImageFromPicker(row) {
            if (this.sortSaving || !this.canAddPickerImage(row)) {
                return;
            }
            row._adding = true;
            axios.post(`/cms/v1/story-collection/${this.collection.id}/image`, {image_id: row.id}).then(res => {
                this.data.push(this.normalizeRowI18n(res.data.data));
                row._adding = false;
                this.resort();
                ElMessage.success('已添加到集合');
            }).catch(e => {
                row._adding = false;
                apiError(e);
            })
        },
        resort() {
            if (this.sortSaving) {
                return;
            }
            const sort = [];
            this.data.forEach(d => {
                sort.push(d.id);
            })
            this.sortSaving = true;
            axios.post(`/cms/v1/sort/story-collection/image`, {sort}).then(_ => {
                this.sortSaving = false;
            }).catch(e => {
                this.sortSaving = false;
                apiError(e);
                this.reloadImages();
            })
        },
    },
    computed: {
        previewRows() {
            return this.preview_rows;
        },
        previewCanTranslate() {
            return this.preview_rows.some(row => row.lang === 'EN' && (row.name || row.desc));
        },
    },
}
</script>

<style scoped>
.story-image-toolbar {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}

.story-image-toolbar h4 {
    margin: 0;
}

.story-image-list {
    min-height: 120px;
    overflow-x: auto;
}

.story-image-header,
.story-image-row {
    display: grid;
    grid-template-columns: 56px 150px 96px 170px minmax(180px, 1fr) minmax(260px, 1.4fr) 100px;
    gap: 8px;
    align-items: center;
    border-bottom: 1px solid var(--el-border-color-lighter);
    padding: 8px 0;
    min-width: 1120px;
}

.story-image-header {
    color: var(--el-text-color-secondary);
    font-weight: 600;
}

.drag-handle {
    color: var(--el-color-primary);
    cursor: grab;
    user-select: none;
}

.story-preview-head {
    align-items: center;
    display: flex;
    gap: 16px;
}

.story-preview-id {
    color: #606266;
    font-weight: 600;
    margin-bottom: 8px;
}

.story-preview-actions {
    align-items: center;
    display: flex;
    gap: 8px;
    margin-top: 16px;
}

.picker-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
</style>
